<skl-dialog-content-ins>
	<skl-dialog-header-ins
		[title]="'scenes.shared.dialog.arrearage-value-range-dialog.title' | translate"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			<div class="grid">
				<div [ngClass]="viewModel.isRangeVisible() ? 'col-1-3' : 'col-1-2'">
					<ins-form-field
						[skl-focus-by]
						[label]="'scenes.shared.dialog.arrearage-value-range-dialog.form.types.label' | translate">
						<ins-select
							display-text="label"
							[converter]="viewModel.typeConverter"
							[(ngModel)]="viewModel.type.value">
							@for (item of viewModel.types; track item) {
								<ins-option
									[value]="item">
									{{item.label}}
								</ins-option>
							}
						</ins-select>
					</ins-form-field>
				</div>
				@if (!viewModel.isRangeVisible()) {
					<div class="col-1-2">
						<ins-form-field
							[label]="'scenes.shared.dialog.arrearage-value-range-dialog.form.chosen-value.to' | translate">
							<ins-input
								inputmode="decimal"
								[(ngModel)]="viewModel.to"
								[precision]="0">
							</ins-input>
							<div slot="end">{{dayText(viewModel.to)}}</div>
						</ins-form-field>
					</div>
				} @else {
					<div>
						<div class="col-1-3">
							<ins-form-field
								[label]="'scenes.shared.dialog.arrearage-value-range-dialog.form.chosen-value.range.from' | translate">
								<ins-input
									inputmode="decimal"
									[(ngModel)]="viewModel.range.from"
									[precision]="0">
								</ins-input>
								<div slot="end">{{dayText(viewModel.range.from)}}</div>
							</ins-form-field>
						</div>
						<div class="col-1-3">
							<ins-form-field
								[label]="'scenes.shared.dialog.arrearage-value-range-dialog.form.chosen-value.range.to' | translate">
								<ins-input
									inputmode="decimal"
									[(ngModel)]="viewModel.range.to"
									[precision]="0">
								</ins-input>
								<div slot="end">{{dayText(viewModel.range.to)}}</div>
								<div slot="end" [ngClass]="{ 'display--none': !viewModel.isValueToInvalid() }">
									<skl-icon
										[tooltip]="'scenes.shared.dialog.arrearage-value-range-dialog.form.chosen-value.range.error' | translate"
										color="error"
										name="exclamation-circle">
									</skl-icon>
								</div>
							</ins-form-field>
						</div>
					</div>
				}
			</div>
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			(click)="onCancel()">
			{{ 'scenes.shared.dialog.arrearage-value-range-dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			typeName="accent"
			(click)="chooseValue()">
			{{ 'scenes.shared.dialog.arrearage-value-range-dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>